export function readCheckoutMessage(messages, namespace, path) {
  const source = namespace ? messages?.[namespace] || {} : messages || {};
  const resolved = String(path || '')
    .split('.')
    .filter(Boolean)
    .reduce((current, segment) => current?.[segment], source);

  return typeof resolved === 'string' ? resolved : '';
}

export function interpolateCheckoutMessage(template, values = {}) {
  if (typeof template !== 'string' || !template) {
    return '';
  }

  return template.replace(/{{\s*([^}]+?)\s*}}/g, (_, key) => {
    const value = values[String(key || '').trim()];
    return value == null ? '' : String(value);
  });
}
